
import state from './moduleCoreFieldsManagementState'
import mutations from './moduleCoreFieldsManagementMutations'
import actions from './moduleCoreFieldsManagementActions'
import getters from './moduleCoreFieldsManagementGetters'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

